export default __webpack_public_path__ + "static/isolate-27c57fb30484ce8341bf83a11f8ce809.png";